import React, { useState } from "react";
import { toast } from "sonner";
import { useT } from "@/lib/LanguageContext";
import * as crmApi from "../api/crmApi";
import { crmErrorMessage } from "../api/crmErrors";
import CrmDialog from "../ui/CrmDialog";
import CrmTextarea from "../ui/CrmTextarea";
import CrmButton from "../ui/CrmButton";
import { CRM } from "../../../constants/testIds/crm";

/**
 * "Add session note?" — offered to the OWNER right after Mark complete (spec worked
 * example: "prompts for a session note, she types two lines"). Saving writes the private
 * note for that booking; "Later" closes, and the note stays writable from the client's
 * Session notes tab.
 */
export default function SessionNotePrompt({ prompt, onClose }) {
  const t = useT("crm");
  const tc = useT("common");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!text.trim() || busy) return;
    setBusy(true);
    try {
      await crmApi.saveSessionNote(prompt.clientId, prompt.bookingId, text.trim());
      toast.success(t("notes.sessionSaved"));
      onClose();
    } catch (e) {
      toast.error(crmErrorMessage(e, t, tc));
    } finally {
      setBusy(false);
    }
  };
  return (
    <CrmDialog
      open
      onOpenChange={(o) => { if (!o) onClose(); }}
      title={t("today.notePromptTitle")}
      description={t("today.notePromptBody", { name: prompt.clientName })}
      testId={CRM.todayNotePrompt}
      footer={(
        <>
          <CrmButton variant="link" onClick={onClose} data-testid={CRM.todayNoteLater}>{t("today.noteLater")}</CrmButton>
          <CrmButton onClick={save} disabled={!text.trim() || busy} data-testid={CRM.todayNoteSave}>{t("common.save")}</CrmButton>
        </>
      )}
    >
      <CrmTextarea value={text} onChange={(e) => setText(e.target.value)} rows={3} aria-label={t("today.notePromptTitle")}
        placeholder={t("notes.sessionPlaceholder")} data-testid={CRM.todayNoteText} />
    </CrmDialog>
  );
}
